import calculateOffset from '../utils/calculateOffset.esm.js';
import { useState, useEffect } from 'react';
import useDidMount from '../utils/useDidMount.esm.js';
import useHotKey from '../utils/useHotKey.esm.js';
import isPageValid from '../utils/isPageValid.esm.js';

function scrollToTopOfDocument() {
  var main = document.body;

  if (main && main.scrollTo) {
    main.scrollTo(0, 0);
  }
}

function usePagination(_ref) {
  var initialPerPage = _ref.perPage,
      _ref$page = _ref.page,
      initialPage = _ref$page === void 0 ? 0 : _ref$page,
      _ref$scrollToTop = _ref.scrollToTop,
      scrollToTop = _ref$scrollToTop === void 0 ? false : _ref$scrollToTop,
      _ref$hotkeys = _ref.hotkeys,
      hotkeys = _ref$hotkeys === void 0 ? false : _ref$hotkeys,
      total = _ref.total;
  var didMount = useDidMount();

  var _useState = useState(initialPage),
      page = _useState[0],
      setPage = _useState[1];

  var _useState2 = useState(initialPerPage),
      perPage = _useState2[0],
      setPerPage = _useState2[1];

  useEffect(function () {
    if (!didMount) return;
    setPage(initialPage); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialPage]);
  useEffect(function () {
    if (!didMount) return;
    setPerPage(initialPerPage); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialPerPage]);
  var offset = calculateOffset({
    page: page,
    perPage: perPage
  });

  var onChange = function onChange(newPage) {
    if (!isPageValid(newPage, perPage, total)) return;
    setPage(newPage);

    if (scrollToTop) {
      scrollToTopOfDocument();
    }
  };

  var onPerPageChange = function onPerPageChange(newPerPage) {
    setPerPage(newPerPage);
  };

  useHotKey(['ArrowLeft', 'PageUp'], function () {
    var newPage = page - 1;
    onChange(newPage);
  }, hotkeys);
  useHotKey(['ArrowRight', 'PageDown'], function () {
    var newPage = page + 1;
    onChange(newPage);
  }, hotkeys);
  return {
    offset: offset,
    page: page,
    perPage: perPage,
    onChange: onChange,
    onPerPageChange: onPerPageChange,
    includeHref: false
  };
}

export default usePagination;
//# sourceMappingURL=index.esm.js.map
